import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewHeartIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    data-testid="new-heart-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 5.95569C1 3.7208 2.89531 2 5.12 2C6.26678 2 7.27587 2.55625 8 3.276C8.72413 2.55625 9.73322 2 10.88 2C13.1047 2 15 3.7208 15 5.95569C15 7.48662 14.3689 8.83292 13.4945 9.97093C12.6217 11.107 11.48 12.0711 10.3868 12.8546C9.96923 13.1538 9.54682 13.4299 9.16022 13.6336C8.79721 13.8248 8.3798 14 8 14C7.6202 14 7.2028 13.8248 6.83978 13.6336C6.45318 13.4299 6.03077 13.1538 5.61323 12.8546C4.52004 12.0711 3.3783 11.107 2.50546 9.97093C1.6311 8.83292 1 7.48662 1 5.95569ZM5.12 3.24138C3.4566 3.24138 2.2 4.50684 2.2 5.95569C2.2 7.11721 2.67663 8.19862 3.44487 9.19852C4.21463 10.2004 5.25034 11.0844 6.29659 11.8342C6.6925 12.1179 7.06539 12.3593 7.38436 12.5274C7.72692 12.7078 7.92533 12.7586 8 12.7586C8.07467 12.7586 8.27308 12.7078 8.61564 12.5274C8.93461 12.3593 9.30751 12.1179 9.70341 11.8342C10.7497 11.0844 11.7854 10.2004 12.5551 9.19852C13.3234 8.19862 13.8 7.11721 13.8 5.95569C13.8 4.50684 12.5434 3.24138 10.88 3.24138C9.92468 3.24138 9.03264 3.8318 8.47565 4.58118C8.36208 4.73398 8.18633 4.82353 8 4.82353C7.81367 4.82353 7.63792 4.73398 7.52435 4.58118C6.96736 3.8318 6.07532 3.24138 5.12 3.24138Z"
      fill="currentColor"
    />
  </Icon>
);
